import { getRandomString } from '../../utilities/index';
/**
 * Generate a random id that is not present in the document at this time
 *
 * @param document The reference to the document object
 * @returns A random generated string
 */
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function generateUniqueId(document, prefix) {
    if (prefix === void 0) { prefix = ''; }
    var prefixString = (prefix !== null && prefix !== void 0 ? prefix : '');
    // eslint-disable-next-line no-constant-condition
    while (true) {
        // The 'A-' will ensure this is always a valid JavaScript ID
        var id = prefixString + 'A-' + getRandomString() + getRandomString();
        if (document.getElementById(id) === null) {
            return id;
        }
    }
}
export { generateUniqueId };
//# sourceMappingURL=generateIds.js.map